export default __webpack_public_path__ + "static/media/notification_survey_icon.61ad3121.svg";